import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'family_responsibilities_1'

export const dataPointDefinition = {
  retracedId: 'family_responsibilities_1',
  name: 'Family responsibilities',
  description:
    'Workers with family responsibilities refers to men and women with responsibilities in relation to their dependent children, or to other members of their immediate family who clearly need their care or support, where such responsibilities restrict their possibilities of preparing for, entering, parti',
  meta: {
    slcpMeta: {
      key: 'wt-dis-21x',
      number: 'WT-DIS-8-14',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-dis-21x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37200,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
